document.addEventListener("DOMContentLoaded", function () {
  const passwordInput = document.querySelector(".show_password_input");
  const toggleButton = document.querySelector(".show_password");

  if(passwordInput  && toggleButton)
  {
    toggleButton.addEventListener("click", function () {
        const isPassword = passwordInput.getAttribute("type") === "password";
        passwordInput.setAttribute("type", isPassword ? "text" : "password");
    });
  }
});
document.addEventListener("DOMContentLoaded", function() {
  var params = new URLSearchParams(window.location.search);
  var targetId = params.get("goto");
  if (targetId) {
    var targetElem = document.getElementById(targetId);
    if (targetElem) {
      setTimeout(function() {
        // Calculate the offset position
        var headerOffset = 100; // height in px of your sticky header + extra margin
        var elementPosition = targetElem.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.scrollY - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }, 100);
    }
  }
});
